import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import './index.css'
import './context/toast.css'
import App from './App.tsx'
import { ToastProvider } from './context/ToastContext.tsx'
import { SocketProvider } from './context/SocketContext.tsx'

// Sentry — error monitoring v produkcii.
// Init odložíme do requestIdleCallback aby nezdržoval LCP (envelope beacon ide hneď po init).
if (import.meta.env.VITE_SENTRY_DSN) {
  const initSentry = () => {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.1,
    });
  };
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initSentry, { timeout: 3000 });
  } else {
    setTimeout(initSentry, 1500);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{padding: 40, textAlign: 'center'}}>Niečo sa pokazilo. Skús obnoviť stránku.</div>}>
      <BrowserRouter>
        <ToastProvider>
          <SocketProvider>
            <App />
          </SocketProvider>
        </ToastProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)